import React from "react";
import { PersonInviteRedemption } from "@wingspanhq/wingspan-api-sdk";
import { InvitationAuthLayout } from "../InvitationAuthLayout";
import { InvitationAuthSignUpForm } from "../InvitationAuthSignUpForm";
import { PAYEES_FEATURES } from "../../static/featuresList";

const PLATFORM_NAME = "Wingspan";

type SignUpPageProps = {
  redemption: PersonInviteRedemption;
};

export const AuthPage: React.FC<SignUpPageProps> = ({ redemption }) => (
  <InvitationAuthLayout
    title={`${PLATFORM_NAME} invited you to onboard`}
    description={
      <>
        {PLATFORM_NAME} is here to make your work life easier by providing
        everything you need in one place.
      </>
    }
    items={PAYEES_FEATURES}
  >
    <InvitationAuthSignUpForm redemption={redemption} />
  </InvitationAuthLayout>
);
